// Emergent-managed Google sign-in button.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GOOGLE_COUNTRY_KEY = "wstf_google_country";

const GoogleG = () => (
  <svg viewBox="0 0 48 48" className="w-5 h-5" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

export function GoogleSignInButton({ label = "Sign in with Google", country, testid = "google-signin-btn" }) {
  const go = () => {
    if (country) sessionStorage.setItem(GOOGLE_COUNTRY_KEY, country);
    else sessionStorage.removeItem(GOOGLE_COUNTRY_KEY);
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" onClick={go} data-testid={testid}
      className="w-full inline-flex items-center justify-center gap-3 rounded-lg border border-[#E5B842]/50 bg-[#0a0a0a] px-4 py-3 text-sm font-bold text-slate-100 hover:border-[#E5B842] hover:bg-[#141007]"
      style={{ transition: "border-color 0.15s ease, background-color 0.15s ease" }}>
      <span className="w-7 h-7 rounded-full bg-white flex items-center justify-center"><GoogleG /></span>
      {label}
    </button>
  );
}

export function OrDivider() {
  return (
    <div className="flex items-center gap-3 text-[10px] font-mono uppercase tracking-[0.25em] text-slate-500">
      <span className="h-px flex-1 bg-[#2b2512]" /> or <span className="h-px flex-1 bg-[#2b2512]" />
    </div>
  );
}
